App.namespace.wrap('es6.shared.pikaday', options => {
  const INTERNAL_DATE_FORMAT = 'DD/MM/YYYY';
  let minDate = new Date();

  if (options.minDate) {
    minDate.setTime(options.minDate);
  } else if (options.noticeHours) {
    minDate.setTime(minDate.getTime() + options.noticeHours * 60 * 60 * 1000);
  }

  minDate.setHours(0, 0, 0, 0);

  if (options.pastDatesEnabled) {
    minDate = null;
  }


  const isClosedDayOfWeek = (date, closedDaysOfWeek) => closedDaysOfWeek.indexOf(date) > -1;
  const isFullyBookedDate = (date, disabledDates) => disabledDates.indexOf(date) > -1;

  let {
    defaultDate = null,
    element,
    onSelect,
    uiDateFormat,
    weekStart,
    closedDaysOfWeek = [],
    fullyBookedDates = [],
    highlightedDates = [],
    hideClearDateButton = false,
    showDaysInNextAndPreviousMonths = true,
  } = options;

  if (defaultDate) {
    defaultDate = dayjs(defaultDate, INTERNAL_DATE_FORMAT);

    if (defaultDate.isBefore(minDate)) {
      defaultDate = dayjs(minDate);
      onSelect(defaultDate.format(INTERNAL_DATE_FORMAT));
    }
  }


  if ([0, 1, 2, 3, 4, 5, 6].indexOf(weekStart) === -1) {
    const msg = 'Got invalid weekStart, falling back to 1';
    console.error(msg, weekStart);
    Rollbar.error(msg, weekStart);
    weekStart = 1;
  }

  if (!uiDateFormat) {
    const msg = 'Got invalid uiDateFormat, falling back to DD/MM/YYYY';
    console.error(msg, uiDateFormat);
    Rollbar.error(msg, uiDateFormat);
    uiDateFormat = 'DD/MM/YYYY';
  }

  // @todo Date format validation.
  const pikaday = new Pikaday({
    ...options,
    defaultDate: defaultDate ? defaultDate.toDate() : null,
    setDefaultDate: true,
    field: element,
    format: uiDateFormat,
    minDate: minDate,
    firstDay: parseInt(weekStart, 10),
    showDaysInNextAndPreviousMonths,
    events: highlightedDates.map(date => dayjs(date, INTERNAL_DATE_FORMAT).toDate().toDateString()),
    toString: (date, format) => dayjs(date).format(format),
    parse: (dateString, format) => dayjs(dateString, format),
    onSelect: date => {
      onSelect && onSelect(date
        ? dayjs(date).format(INTERNAL_DATE_FORMAT)
        : null
      )
    },
    disableDayFn: date => {
      const dayJsDate = dayjs(date);

      return isClosedDayOfWeek(dayJsDate.day(), closedDaysOfWeek)
        || isFullyBookedDate(dayJsDate.format(INTERNAL_DATE_FORMAT), fullyBookedDates)
    },
  });

  element.pikaday = pikaday;

  pikaday.config({
    onDraw: () => {
      if (hideClearDateButton) {
        return;
      }

      const clearButton = document.createElement('button');
      clearButton.className = 'pikaday-clear';
      clearButton.type = 'button';
      clearButton.textContent = 'Clear date';

      const handleClick = () => {
        pikaday.setDate(null);
        pikaday.config().onSelect(null);
      }

      clearButton.addEventListener('click', handleClick);
      clearButton.addEventListener('touchend', handleClick);

      pikaday.el.querySelector('.pika-lendar').appendChild(clearButton);
    },
  });

  // used in e2e tests and for showing datepicker (using pikaday instance) in parent components (vue side)
  window.PIKADAY_INSTANCES = window.PIKADAY_INSTANCES || {};
  const { pikadayId, testId } = element.dataset;
  if (pikadayId || testId) {
    window.PIKADAY_INSTANCES[pikadayId || testId] = pikaday;
  }
  return pikaday;
});
